import React, { Fragment, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import './RelatedContents.scss';

function RelatedContents() {
  const [currentUrl, setCurrentUrl] = useState();
  const [alignLeft, setAlignLeft] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(window.innerWidth);
  const [tiles, setTiles] = useState();
  const [relatedContentsData, setRelatedContentsData] = useState();

  const tileRef = useRef();

  useEffect(() => {
    const path = window.location.pathname;
    const array = path.split('/');
    setCurrentUrl(array[4]);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios(
          'https://cdn.courageousstudios.com/assets/sponsorcontent/destination-canada/destinationCanadaRelatedContents.json'
        );
        const jsonData = JSON.parse(JSON.stringify(result.data));
        const data = jsonData.contents;
        setRelatedContentsData(data);
        setTiles(data.length - 1);
      } catch (error) {
        console.log('theres an error', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setCurrentWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (tileRef.current) {
      const tileWidth = tileRef.current.getBoundingClientRect().width;
      const tilesWidth = tiles * (tileWidth + 20);
      if (currentWidth < tilesWidth) {
        setAlignLeft(true);
      } else {
        setAlignLeft(false);
      }
    }
  }, [tiles, currentWidth]);

  return (
    <section
      className="relatedContents"
      style={alignLeft ? { justifyContent: 'flex-start' } : { justifyContent: 'center' }}
    >
      <span
        className="relatedContents__scroll"
        style={alignLeft ? { visibility: 'visible' } : { visibility: 'hidden' }}
      >
        Scroll{' '}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="9"
          viewBox="0 0 22 9"
          fill="none"
        >
          <path
            d="M21.4717 4.85355C21.667 4.65829 21.667 4.34171 21.4717 4.14645L18.2897 0.964466C18.0945 0.769204 17.7779 0.769204 17.5826 0.964466C17.3874 1.15973 17.3874 1.47631 17.5826 1.67157L20.4111 4.5L17.5826 7.32843C17.3874 7.52369 17.3874 7.84027 17.5826 8.03553C17.7779 8.2308 18.0945 8.2308 18.2897 8.03553L21.4717 4.85355ZM0 5H21.1182V4H0L0 5Z"
            fill="black"
          />
        </svg>
      </span>
      <div className="relatedContents__tiles">
        {relatedContentsData &&
          relatedContentsData.map((data, i) => {
            return (
              <Fragment key={data.content}>
                {currentUrl !== data.endpoint ? (
                  <div
                    className={`relatedContents__tile relatedContents__tile-${data.content}`}
                    key={i}
                    style={{ backgroundImage: `url(${data.background})` }}
                    ref={tileRef}
                  >
                    <div className="relatedContents__tile--contents relatedContents__tile__content">
                      <h4 className="relatedContents__tile__title">{data.title}</h4>
                      <p className="relatedContents__tile__body">
                        {data.body}
                        <br />
                        {data.body2}
                      </p>
                      <a href={data.url} target="_blank" rel="sponsored">
                        <button
                          className="videoPG__cta__button videoPG__cta__button--related"
                          aria-label={data.label}
                        >
                          {data.button}
                        </button>
                      </a>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </Fragment>
            );
          })}
      </div>
    </section>
  );
}

export default RelatedContents;
